import { useAppStore } from '@/store/useAppStore.ts'
import { ScrubInput } from 'calc-controls'
import { getChemistryPreset } from '@brt/shared-logic'
import { HelpIcon } from '@/components/shared/HelpIcon.tsx'
import { solveStorageDaysForRetention } from '@brt/shared-logic'

const TARGET_RETENTION = 0.9
const RECHARGE_DEADLINE_FRACTION = 0.8

export function StorageDaysInput() {
  const storageDays = useAppStore((s) => s.battery.storageDays)
  const chemistry = useAppStore((s) => s.battery.chemistry)
  const updateBattery = useAppStore((s) => s.updateBattery)

  const preset = getChemistryPreset(chemistry)
  const dailyRate = preset.selfDischargePerDay

  const remainingPercent = storageDays > 0
    ? Math.round(Math.pow(1 - dailyRate, storageDays) * 100)
    : 100

  const selfDischargeFactor = storageDays > 0
    ? Math.pow(1 - dailyRate, storageDays)
    : 1

  const showReminder = storageDays > 0 || dailyRate >= 0.001
  const tenPercentDays = solveStorageDaysForRetention(dailyRate, TARGET_RETENTION)
  const tenPercentDaysRounded = Number.isFinite(tenPercentDays)
    ? Math.round(tenPercentDays * 10) / 10
    : null
  const showRechargeNudge = Number.isFinite(tenPercentDays) && storageDays >= RECHARGE_DEADLINE_FRACTION * tenPercentDays
  const rechargeWithinDays = Number.isFinite(tenPercentDays)
    ? Math.max(0, Math.round((tenPercentDays - storageDays) * 10) / 10)
    : null

  return (
    <div className="storage-days-input">
      <div className="storage-days-input__header">
        <HelpIcon text="Models capacity loss from self-discharge during storage. The daily rate is determined by battery chemistry.">
          <span className="storage-days-input__rate">
            Self-discharge: {(dailyRate * 100).toFixed(2)}%/day
          </span>
        </HelpIcon>
      </div>
      <ScrubInput
        label="Storage Days"
        value={storageDays || 0}
        onChange={(v) => updateBattery('storageDays', Math.min(365, Math.max(0, Math.round(v))))}
        unit="days"
        min={0}
        max={365}
        step={1}
        decimals={0}
      />
      {storageDays > 0 && (
        <div className="storage-days-input__result">
          <span className="storage-days-input__remaining">
            Remaining charge: {remainingPercent}%
          </span>
          <span className="storage-days-input__factor">
            (×{selfDischargeFactor.toFixed(3)})
          </span>
        </div>
      )}
      {showReminder && tenPercentDaysRounded != null && (
        <p className="storage-days-input__reminder" data-testid="shelf-life-reminder">
          Loses ~10% in ~{tenPercentDaysRounded} days
          {showRechargeNudge && rechargeWithinDays != null
            ? ` — recharge within ~${rechargeWithinDays} days`
            : ''}
        </p>
      )}
    </div>
  )
}
